import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import DataTable from '../../../../components/DataTable'
import { nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../components/Container'
import { useToast } from 'hooks/toast'
import { FaWhatsapp } from 'react-icons/fa'
import Modal from 'components/Modal'
import { SendMessageByMenuFoods } from '../components/SendMessageByMenuFoodsForm'
import Form, { Select } from 'components/Form'
import { situations } from 'pages/Commercial/MenuFoods/Register/domain/info'

const parseIsActive = (situation: string | null): boolean | undefined => {
  if (situation === 'false') {
    return false
  }
  if (situation === 'true') {
    return true
  }
  return undefined
}

const InstitutionList = (): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const locationSearch = new URLSearchParams(useLocation().search)
  const [situation, setSituation] = useState<string>('true')
  const [parameters, setParameters] = useState<any>([{ is_active: true }])
  const [modalMessage, setModalMessage] = useState<{
    open: boolean
    id: number
    name?: string
  }>()

  const handleClickOnCloseModal = (): void => {
    setModalMessage({
      id: 0,
      open: false
    })
  }

  const onSearch = (): void => {
    const query = []
    if (situation) {
      query.push(`is_active=${situation}`)
    }

    history.replace(
      `/commercial/institutions${query.length ? `?${query.join('&')}` : ''}`
    )

    const is_active = parseIsActive(situation || null)
    if (is_active !== undefined) {
      setParameters([{ is_active }])
    } else {
      setParameters([])
    }
  }

  useEffect(() => {
    const situationParam = locationSearch.get('is_active')
    if (situationParam === null) {
      return
    }

    const is_active = parseIsActive(situationParam)
    setSituation(situationParam)
    if (is_active !== undefined) {
      setParameters([{ is_active }])
    } else {
      setParameters([])
    }
  }, [])

  return (
    <Container
      pageTitle="Listagem"
      breadcrumb={breadcrumbList}
      tools={toolsList}
    >
      <div className="col-md-12">
        <Form onSubmit={onSearch} defaultValues={{}} className="col-md-12">
          <div className="col-md-12 d-flex align-items-end">
            <div className="col-md-2">
              <Select
                label="Ativo"
                name="is_active"
                options={situations}
                onChange={e => setSituation(e.target.value)}
                value={situation}
                controlled
                blank
                defaultValue={''}
                className="w-100"
              />
            </div>
          </div>
          <footer className="col-md-12 d-flex justify-content-end pb-5 gap-5">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                setSituation('true')
                history.replace('/commercial/institutions')
                setParameters([{ is_active: true }])
              }}
            >
              LIMPAR
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              BUSCAR
            </button>
          </footer>
        </Form>
        <hr />
      </div>
      <button
        className="btn btn-sm btn-primary flex-end align-items-end justify-content-end h-40px mt-2"
        type="button"
        onClick={() => {
          setModalMessage({
            open: true,
            id: 0,
            name: 'Todas as instituições'
          })
        }}
      >
        <span
          style={{
            display: 'flex',
            alignItems: 'end'
          }}
        >
          <span style={{ marginRight: '5px' }}>
            <FaWhatsapp size={20} />
          </span>
          Envio geral
        </span>
      </button>

      <DataTable
        source={nameSource}
        entity={nameEntity}
        format={{ orderBy: 'company_social_name' }}
        headers={headers}
        searchParameters={parameters}
        actions={[
          {
            name: 'Visualizar',
            title: 'Visualizar',
            spanIcon: 'fa fa-search',
            linkTo: institutition =>
              `/commercial/institutions/view/${institutition.id}`,
            style: { margin: '0 5px' }
          },
          {
            name: 'Editar',
            title: 'Editar',
            spanIcon: 'fa fa-edit',
            linkTo: institution =>
              `/commercial/institutions/update/${institution.id}`
          },
          {
            name: 'Copiar link',
            title: 'Copiar',
            style: { margin: '0 5px' },
            spanIcon: 'fa fa-clipboard',
            onClick: institution => {
              console.log(process.env.REACT_APP_CLIENT_URL)
              navigator.clipboard.writeText(
                `https://contratacao.merenderia.com.br/contract/${institution.token}`
              )
              addToast({
                type: 'success',
                title: 'Link da instituição copiado com sucesso!'
              })
            }
          },
          {
            name: 'Enviar mensagem',
            title: 'Enviar mensagem',
            htmlIcon: (
              <div style={{ marginLeft: '5px' }}>
                <FaWhatsapp size={15} />
              </div>
            ),
            onClick: institution => {
              setModalMessage({
                open: true,
                id: Number(institution.id),
                name: institution.company_social_name
              })
            }
          }
        ]}
      />
      {modalMessage && (
        <Modal
          pageTitle={`Enviar mensagem para ${modalMessage.name}`}
          onClickButtonCancel={handleClickOnCloseModal}
          isOpenModal={modalMessage.open}
          style={{
            stylesModal: {
              maxHeight: '80vh'
            }
          }}
          Children={
            <SendMessageByMenuFoods
              id={modalMessage.id}
              handleClickOnCloseModal={handleClickOnCloseModal}
            />
          }
        />
      )}
    </Container>
  )
}

export default InstitutionList
